import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/users'
import { Button } from '@radix-ui/themes'
import { useEffect, useState } from 'react'
import AddSSOMembersModal from '../members/AddSSOMembersModal'
import DisconnectModal from './DisconnectModal'
import ContentSkeleton from '../skeleton/ContentSkeleton'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'
import toast from 'react-hot-toast'

function SsoSettings() {
  const { session } = useSelector(selectUser)
  const ssoConfigured = localStorage.getItem('SSO_CONFIGURED_COOKIE')
  const [showDisconnectModal, setShowDisconnectModal] = useState<boolean>(false)
  const [showSSOModal, setShowSSOModal] = useState<boolean>(false)

  useEffect(() => {
    if (ssoConfigured) {
      toast.success('SSO configured successfully', DEFAULT_TOAST_CONFIG)
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
    }
  }, [])

  const hasSso = () => {
    return (
      <>
        <div className="italic">
          {session!.organization.ssoProvider.charAt(0).toUpperCase() + session!.organization.ssoProvider.slice(1)}{' '}
          configured
        </div>
        <Button className="bg-ErrorRed mt-4" onClick={() => setShowDisconnectModal(true)}>
          Disconnect
        </Button>
      </>
    )
  }

  const ssoNotConfiguredBody = (
    <>
      <div className="italic">Not yet configured</div>
      <Button
        className="mt-4 bg-mainPurple cursor-pointer"
        onClick={() => {
          setShowSSOModal(true)
        }}
      >
        Set Up SSO
      </Button>
    </>
  )

  const ssoTabBody = session?.organization.ssoProvider ? hasSso() : ssoNotConfiguredBody

  return (
    <>
      <div className="w-full h-full mt-6">
        {!session && <ContentSkeleton />}
        {session && ssoTabBody}
      </div>
      {showDisconnectModal && <DisconnectModal setShowModal={setShowDisconnectModal} screen={'SSO'} />}
      {showSSOModal && <AddSSOMembersModal setShowModal={setShowSSOModal} />}
    </>
  )
}

export default SsoSettings
